import React from "react";
import { Toast, ToastHeader, ToastBody} from 'reactstrap';

const SimpleToast = (props) => {

    const {toaster} = props

    if (toaster.className === "") return <></>

    return (<>
      <div className={toaster.className}>
            <Toast>
            <ToastHeader>
                Result
            </ToastHeader>
            <ToastBody>
                {toaster.body}
            </ToastBody>
            </Toast>
        </div>  
    </>
    )
}
export default SimpleToast